/* ExtraCM — Pop-up de bienvenida (email → código 10% → Klaviyo). Fichero propio del tema (no se genera).
   24-oct-2026 (10 % en el primer PEDIDO: Shopify no permite limitar un porcentaje a una unidad): sustituye al "rasca y gana" a pantalla completa. Tarjeta centrada en dos paneles
   (foto del producto con la insignia −10% · texto, correo y botón), como el pop-up de Comfavia que
   trajo el usuario. El código se ENSEÑA al momento (no se promete por correo): si no lo usa, Klaviyo
   se lo manda después. Sale en la portada y en la ficha (test 2 cerrado: la B, con pop-up, ganó).
   Multi-idioma (lee <html lang>), manda el email a Klaviyo por su API cliente.
   TEST: añade #lead-test a la URL para forzarlo. Reset: localStorage.removeItem('extracm_lead').
   Disparo (Evolve Q4 / Alia): escritorio 8 s + 40 % de scroll, móvil 10 s, o intento de salida (escritorio). */
(function () {
  'use strict';

  var KLAVIYO_COMPANY_ID = 'RqxvBG';
  var KLAVIYO_LIST_ID    = 'R4XHWN';
  var DISCOUNT_CODE      = 'WELCOME10';   // el mismo que manda la agencia en su correo de bienvenida
  var KLAVIYO_REVISION   = '2024-10-15';
  var STORE_KEY   = 'extracm_lead';
  var DISMISS_DAYS = 3;
  var DELAY_MOBILE  = 10000;
  var DELAY_DESKTOP = 8000;     // también tablet
  var SCROLL_DESKTOP = 0.40;    // solo escritorio: además del tiempo, 40 % de la página
  var isMobile = window.innerWidth < 768;
  var isDesktop = window.innerWidth >= 1024;
  var ECM = window.ECM || {};
  var IMG_INSOLE = (ECM.assets || {}).scratchInsole || '';

  var forced = location.hash.indexOf('lead-test') !== -1;
  var stored = null;
  try { stored = localStorage.getItem(STORE_KEY); } catch (e) {}
  if (!forced) {
    if (stored === 'subscribed') return;
    if (stored && stored.indexOf('dismissed:') === 0) {
      var ts = parseInt(stored.split(':')[1], 10) || 0;
      if (Date.now() - ts < DISMISS_DAYS * 864e5) return;
    }
  }

  var page = (document.body && document.body.dataset.page) || '';
  if (!forced && page !== 'home' && page !== 'buy') return;
  var langFull = (document.documentElement.lang || 'en').toLowerCase();
  var lang = langFull.split('-')[0];
  var market = String(ECM.country || 'GB').toLowerCase();
  if (market === 'gb') market = 'uk';
  var abVariant = window.ECM_AB || (document.cookie.match(/(?:^|;\s*)extracm_ab=([AB])/) || [])[1] || '';

  var T = {
    en: { kicker:'Welcome to ExtraCM', h:'10% off your first order.', sub:'Leave your email and get your discount code right away.',
          ph:'Your email address', cta:'I want my 10%', no:'No, thanks', fine:'No spam. Unsubscribe anytime.', b1:'−10%', b2:'first order',
          okk:'Your code', okh:'Here’s your 10%.', okp:'Enter it at checkout: it applies to your whole order.', copy:'Copy code', copied:'Copied!', shop:'Shop now →',
          bad:'Please enter a valid email.', aria:'10% discount offer', close:'Close' },
    es: { kicker:'Bienvenido a ExtraCM', h:'Un 10% menos en tu primer pedido.', sub:'Déjanos tu correo y obtén tu código de descuento al momento.',
          ph:'Tu correo electrónico', cta:'Quiero mi 10%', no:'No, gracias', fine:'Sin spam. Te das de baja cuando quieras.', b1:'−10%', b2:'primer pedido',
          okk:'Tu código', okh:'Aquí tienes tu 10%.', okp:'Introdúcelo al pagar: se aplica a todo tu pedido.', copy:'Copiar código', copied:'¡Copiado!', shop:'Comprar ahora →',
          bad:'Introduce un correo válido.', aria:'Oferta 10% de descuento', close:'Cerrar' },
    de: { kicker:'Willkommen bei ExtraCM', h:'10% Rabatt auf deine erste Bestellung.', sub:'Hinterlass deine E-Mail und erhalte sofort deinen Rabattcode.',
          ph:'Deine E-Mail-Adresse', cta:'Ich will meine 10%', no:'Nein, danke', fine:'Kein Spam. Jederzeit abmeldbar.', b1:'−10%', b2:'erste Bestellung',
          okk:'Dein Code', okh:'Hier sind deine 10%.', okp:'Gib ihn an der Kasse ein: er gilt für die ganze Bestellung.', copy:'Code kopieren', copied:'Kopiert!', shop:'Jetzt kaufen →',
          bad:'Bitte gib eine gültige E-Mail ein.', aria:'Angebot 10% Rabatt', close:'Schließen' },
    fr: { kicker:'Bienvenue chez ExtraCM', h:'10% de remise sur votre première commande.', sub:'Laissez votre e-mail et recevez votre code de réduction immédiatement.',
          ph:'Votre adresse e-mail', cta:'Je veux mes 10%', no:'Non, merci', fine:'Pas de spam. Désabonnement à tout moment.', b1:'−10%', b2:'première commande',
          okk:'Votre code', okh:'Voici vos 10%.', okp:'Saisissez-le au paiement : il s’applique à toute la commande.', copy:'Copier le code', copied:'Copié !', shop:'Acheter →',
          bad:'Entrez un e-mail valide.', aria:'Offre -10%', close:'Fermer' },
    it: { kicker:'Benvenuto in ExtraCM', h:'10% di sconto sul tuo primo ordine.', sub:'Lasciaci la tua email e ottieni subito il tuo codice sconto.',
          ph:'La tua email', cta:'Voglio il mio 10%', no:'No, grazie', fine:'Niente spam. Ti disiscrivi quando vuoi.', b1:'−10%', b2:'primo ordine',
          okk:'Il tuo codice', okh:'Ecco il tuo 10%.', okp:'Inseriscilo al checkout: vale su tutto l’ordine.', copy:'Copia codice', copied:'Copiato!', shop:'Acquista ora →',
          bad:'Inserisci un’email valida.', aria:'Offerta -10%', close:'Chiudi' },
    pt: { kicker:'Bem-vindo à ExtraCM', h:'10% de desconto na tua primeira encomenda.', sub:'Deixa o teu email e recebe já o teu código de desconto.',
          ph:'O teu email', cta:'Quero os meus 10%', no:'Não, obrigado', fine:'Sem spam. Cancelas quando quiseres.', b1:'−10%', b2:'primeira encomenda',
          okk:'O teu código', okh:'Aqui tens os teus 10%.', okp:'Introduz o código no pagamento: aplica-se a toda a encomenda.', copy:'Copiar código', copied:'Copiado!', shop:'Comprar agora →',
          bad:'Introduz um email válido.', aria:'Oferta -10%', close:'Fechar' },
    nl: { kicker:'Welkom bij ExtraCM', h:'10% korting op je eerste bestelling.', sub:'Laat je e-mailadres achter en ontvang direct je kortingscode.',
          ph:'Je e-mailadres', cta:'Ik wil mijn 10%', no:'Nee, bedankt', fine:'Geen spam. Afmelden kan altijd.', b1:'−10%', b2:'eerste bestelling',
          okk:'Je code', okh:'Hier is je 10%.', okp:'Vul hem in bij het afrekenen: geldig op je hele bestelling.', copy:'Code kopiëren', copied:'Gekopieerd!', shop:'Nu kopen →',
          bad:'Vul een geldig e-mailadres in.', aria:'Aanbieding 10% korting', close:'Sluiten' },
    pl: { kicker:'Witaj w ExtraCM', h:'10% taniej na pierwsze zamówienie.', sub:'Zostaw swój e-mail i od razu odbierz kod rabatowy.',
          ph:'Twój adres e-mail', cta:'Chcę moje 10%', no:'Nie, dziękuję', fine:'Bez spamu. Wypiszesz się, kiedy chcesz.', b1:'−10%', b2:'pierwsze zamówienie',
          okk:'Twój kod', okh:'Oto Twoje 10%.', okp:'Wpisz go przy kasie: obowiązuje na całe zamówienie.', copy:'Kopiuj kod', copied:'Skopiowano!', shop:'Kup teraz →',
          bad:'Podaj poprawny e-mail.', aria:'Oferta -10%', close:'Zamknij' },
    cs: { kicker:'Vítej v ExtraCM', h:'10% sleva na první objednávku.', sub:'Nech nám svůj e-mail a hned získej slevový kód.',
          ph:'Tvůj e-mail', cta:'Chci svých 10 %', no:'Ne, děkuji', fine:'Žádný spam. Odhlásit se můžeš kdykoli.', b1:'−10%', b2:'první objednávka',
          okk:'Tvůj kód', okh:'Tady je tvých 10 %.', okp:'Zadej ho u pokladny: platí na celou objednávku.', copy:'Kopírovat kód', copied:'Zkopírováno!', shop:'Nakoupit →',
          bad:'Zadej platný e-mail.', aria:'Nabídka sleva 10 %', close:'Zavřít' },
    el: { kicker:'Καλώς ήρθες στην ExtraCM', h:'10% έκπτωση στην πρώτη σου παραγγελία.', sub:'Άφησε το email σου και πάρε αμέσως τον κωδικό έκπτωσης.',
          ph:'Το email σου', cta:'Θέλω το 10% μου', no:'Όχι, ευχαριστώ', fine:'Χωρίς spam. Διαγράφεσαι όποτε θέλεις.', b1:'−10%', b2:'πρώτη παραγγελία',
          okk:'Ο κωδικός σου', okh:'Ορίστε το 10% σου.', okp:'Βάλ’ τον στο ταμείο: ισχύει σε όλη την παραγγελία.', copy:'Αντιγραφή κωδικού', copied:'Αντιγράφηκε!', shop:'Αγόρασε τώρα →',
          bad:'Βάλε ένα έγκυρο email.', aria:'Προσφορά έκπτωσης 10%', close:'Κλείσιμο' },
    ja: { kicker:'ExtraCMへようこそ', h:'初回のご注文が10%OFF。', sub:'メールアドレスを入力すると、すぐにクーポンコードが表示されます。',
          ph:'メールアドレス', cta:'10%OFFを受け取る', no:'結構です', fine:'迷惑メールは送りません。いつでも解除できます。', b1:'10%', b2:'OFF・初回注文',
          okk:'クーポンコード', okh:'10%OFFクーポンです。', okp:'お会計時に入力すると、ご注文全体に割引が適用されます。', copy:'コードをコピー', copied:'コピーしました！', shop:'今すぐ購入 →',
          bad:'正しいメールアドレスを入力してください。', aria:'10%OFFクーポン', close:'閉じる' }
  };
  var t = T[langFull] || T[lang] || T.en;

  var css =
    '#ecm-lead-ov{position:fixed;inset:0;z-index:2147483500;display:flex;align-items:center;justify-content:center;padding:16px;box-sizing:border-box;'
    + 'background:rgba(5,9,21,.62);-webkit-backdrop-filter:blur(3px);backdrop-filter:blur(3px);'
    + 'font-family:"DM Sans",-apple-system,"Helvetica Neue",Arial,sans-serif;animation:ecmFade .25s ease-out}'
    + '@keyframes ecmFade{from{opacity:0}to{opacity:1}}'
    + '@keyframes ecmPop{from{opacity:0;transform:translateY(14px) scale(.98)}to{opacity:1;transform:none}}'
    + '#ecm-lead{position:relative;display:grid;grid-template-columns:42% 1fr;width:100%;max-width:860px;max-height:92vh;max-height:92dvh;overflow:hidden;'
    + 'background:#fff;color:#0A0A0A;border-radius:22px;box-shadow:0 30px 80px rgba(0,0,0,.45);animation:ecmPop .35s cubic-bezier(.16,1,.3,1);text-align:left}'
    + '#ecm-lead *{box-sizing:border-box}'
    + '#ecm-lead .ecm-w__art{position:relative;overflow:hidden;min-height:440px;display:flex;align-items:center;justify-content:center;'
    + 'background:radial-gradient(120% 100% at 30% 15%,#2440c4 0%,#0f1f6e 48%,#070f3a 100%)}'
    + '#ecm-lead .ecm-w__art img{width:90%;max-width:380px;transform:rotate(-14deg);filter:drop-shadow(0 26px 30px rgba(0,0,0,.5))}'
    + '#ecm-lead .ecm-w__badge{position:absolute;top:22px;left:22px;width:112px;height:112px;border-radius:50%;background:#0A0A0A;color:#fff;'
    + 'display:flex;flex-direction:column;align-items:center;justify-content:center;transform:rotate(-8deg);box-shadow:0 10px 24px rgba(0,0,0,.35)}'
    + '#ecm-lead .ecm-w__badge b{font-size:34px;font-weight:800;letter-spacing:-.03em;line-height:1}'
    + '#ecm-lead .ecm-w__badge small{font-size:10px;letter-spacing:.12em;text-transform:uppercase;margin-top:5px;opacity:.92;text-align:center;padding:0 8px;line-height:1.15}'
    + '#ecm-lead .ecm-w__body{position:relative;padding:46px 44px 34px;display:flex;flex-direction:column;justify-content:center}'
    + '#ecm-lead .ecm-x{position:absolute;top:14px;right:14px;z-index:2;width:40px;height:40px;border:0;background:transparent;color:#0A0A0A;font-size:30px;line-height:1;cursor:pointer;border-radius:50%;font-family:inherit}'
    + '#ecm-lead .ecm-x:hover{background:#f1f3f5}'
    + '#ecm-lead .ecm-w__kicker{margin:0 0 12px;font-size:11px;font-weight:800;letter-spacing:.2em;text-transform:uppercase;color:#6b7280}'
    + '#ecm-lead h2{margin:0 0 14px;font-size:36px;line-height:1.08;font-weight:800;letter-spacing:-.02em;color:#0A0A0A;text-wrap:balance}'
    + '#ecm-lead .ecm-w__sub{margin:0 0 22px;font-size:16px;line-height:1.5;color:#4b5563}'
    + '#ecm-lead form{display:flex;flex-direction:column;gap:12px}'
    + '#ecm-lead input[type=email]{width:100%;padding:15px 18px;font-size:16px;border:1.5px solid #d6dae0;border-radius:10px;background:#fff;color:#0A0A0A;font-family:inherit}'
    + '#ecm-lead input[type=email]::placeholder{color:#8a949c}#ecm-lead input[type=email]:focus{outline:none;border-color:#0A0A0A;box-shadow:0 0 0 3px rgba(10,10,10,.08)}'
    + '#ecm-lead .ecm-btn{display:block;width:100%;padding:16px 18px;font-size:15px;font-weight:800;letter-spacing:.06em;text-transform:uppercase;color:#fff;background:#0A0A0A;border:0;border-radius:10px;cursor:pointer;font-family:inherit;text-decoration:none;transition:background .15s}'
    + '#ecm-lead .ecm-btn:hover{background:#222}#ecm-lead .ecm-btn[disabled]{opacity:.6;cursor:default}'
    + '#ecm-lead .ecm-err{color:#c0392b;font-size:13px;min-height:16px;margin:-4px 0 0}'
    + '#ecm-lead .ecm-no{display:block;margin:16px auto 0;background:none;border:0;color:#4b5563;font-size:14px;font-weight:700;cursor:pointer;text-decoration:underline;text-underline-offset:3px;font-family:inherit}'
    + '#ecm-lead .ecm-w__fine{margin:14px 0 0;text-align:center;font-size:12px;color:#6b7280}'
    + '#ecm-lead .ecm-code{display:flex;align-items:center;justify-content:space-between;gap:10px;margin:0 0 14px;padding:14px 18px;border:1.5px dashed #0A0A0A;border-radius:12px;background:#f7f8fa}'
    + '#ecm-lead .ecm-code b{font-size:24px;font-weight:800;letter-spacing:.1em;color:#0A0A0A}'
    + '#ecm-lead .ecm-copy{cursor:pointer;padding:9px 14px;font-size:13px;font-weight:700;color:#fff;background:#0A0A0A;border:0;border-radius:8px;font-family:inherit;white-space:nowrap}'
    + '@media(max-width:719px){'
    + '#ecm-lead{grid-template-columns:1fr;max-width:440px;overflow-y:auto}'
    + '#ecm-lead .ecm-w__art{min-height:0;height:170px}'
    + '#ecm-lead .ecm-w__art img{width:auto;height:150px;max-width:72%;object-fit:contain;transform:rotate(-12deg) translateX(8%)}'
    + '#ecm-lead .ecm-w__badge{width:88px;height:88px;top:14px;left:14px}#ecm-lead .ecm-w__badge b{font-size:26px}#ecm-lead .ecm-w__badge small{font-size:8.5px;padding:0 6px}'
    + '#ecm-lead .ecm-w__body{padding:24px 20px 20px}'
    + '#ecm-lead .ecm-x{top:10px;right:10px;color:#fff;background:rgba(0,0,0,.35)}#ecm-lead .ecm-x:hover{background:rgba(0,0,0,.5)}'
    + '#ecm-lead h2{font-size:27px;margin-bottom:10px}#ecm-lead .ecm-w__sub{font-size:15px;margin-bottom:16px}#ecm-lead .ecm-w__kicker{margin-bottom:8px}'
    + '#ecm-lead input[type=email],#ecm-lead .ecm-btn{padding:14px 16px}#ecm-lead .ecm-no{margin-top:12px}#ecm-lead .ecm-w__fine{margin-top:10px}'
    + '}';

  function persist(v) { try { localStorage.setItem(STORE_KEY, v); } catch (e) {} }
  function validEmail(e) { return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(e); }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&':'&amp;', '<':'&lt;', '>':'&gt;', '"':'&quot;' }[c]; }); }

  var root = null, box = null, step = 'form';
  function track(n, p) { try { (window.ecmq = window.ecmq || []).push([n, p || null]); } catch (e) {} }
  function close(reason) {
    if (reason === 'dismiss') track('popup_decline', { step: step });
    if (root && root.parentNode) root.parentNode.removeChild(root);
    root = null; box = null;
    document.removeEventListener('keydown', onKey);
    document.documentElement.style.overflow = '';
    if (reason === 'dismiss') persist('dismissed:' + Date.now());
  }
  function onKey(e) { if (e.key === 'Escape') close('dismiss'); }

  function toKlaviyo(email) {
    if (!KLAVIYO_COMPANY_ID || !KLAVIYO_LIST_ID) return Promise.resolve();
    return fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(KLAVIYO_COMPANY_ID), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', revision: KLAVIYO_REVISION },
      body: JSON.stringify({ data: { type: 'subscription', attributes: {
        custom_source: 'ExtraCM shop popup',
        profile: { data: { type: 'profile', attributes: { email: email,
          properties: { signup_source: 'web_popup', signup_language: lang, signup_market: market, ab_variant: abVariant, signup_channel: 'shopify_theme' } } } }
      }, relationships: { list: { data: { type: 'list', id: KLAVIYO_LIST_ID } } } } })
    }).then(function (r) {
      if (!r.ok && r.status !== 202) throw new Error('Klaviyo ' + r.status);
      try { window.klaviyo = window.klaviyo || []; window.klaviyo.push(['identify', { $email: email }]); } catch (e) {}
    });
  }

  // ---------- pasos (solo cambia el panel de la derecha) ----------
  function stepForm() {
    step = 'form';
    box.innerHTML =
      '<p class="ecm-w__kicker">' + esc(t.kicker) + '</p>'
      + '<h2>' + esc(t.h) + '</h2>'
      + '<p class="ecm-w__sub">' + esc(t.sub) + '</p>'
      + '<form novalidate>'
      +   '<input type="email" autocomplete="email" placeholder="' + esc(t.ph) + '" aria-label="' + esc(t.ph) + '" required>'
      +   '<div class="ecm-err" aria-live="polite"></div>'
      +   '<button type="submit" class="ecm-btn">' + esc(t.cta) + '</button>'
      + '</form>'
      + '<button type="button" class="ecm-no">' + esc(t.no) + '</button>'
      + '<p class="ecm-w__fine">' + esc(t.fine) + '</p>';
    var form = box.querySelector('form'), input = form.querySelector('input'), errEl = form.querySelector('.ecm-err'), cta = form.querySelector('.ecm-btn');
    box.querySelector('.ecm-no').addEventListener('click', function () { close('dismiss'); });
    if (!isMobile) setTimeout(function () { try { input.focus(); } catch (e) {} }, 80);
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var email = (input.value || '').trim();
      if (!validEmail(email)) { errEl.textContent = t.bad; input.focus(); return; }
      errEl.textContent = ''; cta.disabled = true; cta.textContent = '…';
      persist('subscribed');
      track('popup_email');
      // Triple Whale: con el email une esta visita con sus visitas y compras futuras (solo con consentimiento; lo gestiona consent.js).
      try { if (window.ExtraCMConsent && window.ExtraCMConsent.tw) window.ExtraCMConsent.tw('Contact', { email: email }); } catch (e) {}
      try { localStorage.setItem('extracm_discount', DISCOUNT_CODE); } catch (e) {}
      toKlaviyo(email).then(stepDone).catch(function () { stepDone(); });
    });
  }

  function stepDone() {
    step = 'done';
    box.innerHTML =
      '<p class="ecm-w__kicker">' + esc(t.okk) + '</p>'
      + '<h2>' + esc(t.okh) + '</h2>'
      + '<div class="ecm-code"><b>' + esc(DISCOUNT_CODE) + '</b><button type="button" class="ecm-copy">' + esc(t.copy) + '</button></div>'
      + '<p class="ecm-w__sub">' + esc(t.okp) + '</p>'
      + '<button type="button" class="ecm-btn ecm-shopbtn">' + esc(t.shop) + '</button>';
    box.querySelector('.ecm-copy').addEventListener('click', function () {
      var btn = this, done = function () { btn.textContent = t.copied; };
      try { if (navigator.clipboard) navigator.clipboard.writeText(DISCOUNT_CODE).then(done, done); else done(); } catch (e) { done(); }
    });
    box.querySelector('.ecm-shopbtn').addEventListener('click', function () { close(); });
  }

  function render() {
    if (document.getElementById('ecm-lead-ov')) return;
    if (!document.getElementById('ecm-lead-styles')) {
      var st = document.createElement('style'); st.id = 'ecm-lead-styles'; st.textContent = css; document.head.appendChild(st);
    }
    root = document.createElement('div');
    root.id = 'ecm-lead-ov';
    root.innerHTML =
      '<div id="ecm-lead" role="dialog" aria-modal="true" aria-label="' + esc(t.aria) + '">'
      +   '<div class="ecm-w__art" aria-hidden="true">'
      +     (IMG_INSOLE ? '<img src="' + esc(IMG_INSOLE) + '" alt="">' : '')
      +     '<div class="ecm-w__badge"><b>' + esc(t.b1) + '</b><small>' + esc(t.b2) + '</small></div>'
      +   '</div>'
      +   '<div class="ecm-w__body"></div>'
      +   '<button type="button" class="ecm-x" aria-label="' + esc(t.close) + '">×</button>'
      + '</div>';
    document.body.appendChild(root);
    document.documentElement.style.overflow = 'hidden';
    box = root.querySelector('.ecm-w__body');
    root.querySelector('.ecm-x').addEventListener('click', function () { close('dismiss'); });
    root.addEventListener('click', function (e) { if (e.target === root) close('dismiss'); });   // fuera de la tarjeta = cerrar
    document.addEventListener('keydown', onKey);
    shownAt = Date.now();
    track('popup_show', { trigger: forced ? 'hash' : (shownBy || 'delay') });
    stepForm();
  }

  var shown = false, shownAt = 0, shownBy = '';
  /* 25-oct-2026: el que ya tiene algo en el carrito no ve el pop-up. En móvil salía a los 10 s encima del
     carrito abierto y tapaba «Pagar». Con el carrito vacío y una ventana abierta (la talla), espera. */
  function inCart() {
    var b = document.getElementById('cartBadge');
    return !!(b && parseInt(b.textContent, 10) > 0);
  }
  function trigger() {
    if (shown) return;
    if (!forced && inCart()) return;
    if (!forced && document.body && document.body.classList.contains('modal-open')) { setTimeout(trigger, 2500); return; }
    if (!forced && (document.getElementById('cc-banner') || document.getElementById('shopify-pc__banner'))) { setTimeout(trigger, 2500); return; }
    shown = true; render();
  }
  function arm() {
    if (forced) { trigger(); return; }
    var timeOk = false, scrollOk = !isDesktop;   // en móvil y tablet solo cuenta el tiempo
    function maybe() { if (timeOk && scrollOk) trigger(); }
    setTimeout(function () { timeOk = true; shownBy = shownBy || 'delay'; maybe(); }, isMobile ? DELAY_MOBILE : DELAY_DESKTOP);
    if (isDesktop) {
      var onScroll = function () {
        var h = document.documentElement.scrollHeight || 1;
        if ((window.scrollY + window.innerHeight) / h >= SCROLL_DESKTOP) { window.removeEventListener('scroll', onScroll); scrollOk = true; shownBy = 'scroll'; maybe(); }
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();   // una página corta ya está "recorrida"
    }
    document.addEventListener('mouseout', function onOut(e) {
      if (!e.relatedTarget && e.clientY <= 0) { document.removeEventListener('mouseout', onOut); shownBy = 'exit'; trigger(); }
    });
  }
  window.ExtraCMLead = { open: function () { shown = true; render(); } };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arm); else arm();
})();
